import React from "react";
import { useTheme } from "@mui/material/styles";

const GreenCheckIcon = () => {
  const theme = useTheme();
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="check">
        <path id="Icon" d="M10 3L4.5 8.5L2 6" stroke={theme.palette.success[500]} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
};

export default GreenCheckIcon;
